import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Option = {
  option_id?: number; // 옵션 idx
  option_title?: string; // 옵션 명
  option_type?: string; // 옵션 타입
  option?: { [key: string]: string | number }; // 옵션
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Option
   * --
   */
  getOptions: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_OPTION, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Option
   * --
   */
  getOption: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_OPTION, { option_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Option
   * --
   */
  createOption: async (body: Option) => {
    try {
      const res = await $http.post(APIConstant.CREATE_OPTION, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Option
   * --
   */
  updateOption: async (body: Option) => {
    try {
      const { option_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_OPTION, {
        option_id: option_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Option
   * --
   */
  deleteOption: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_OPTION, {
        option_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
